import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Pergunta } from "../types/general";

const defaultValues = {
  data: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalData: 0
  }
}

interface PerguntaZusProps {
  perguntas: {
    data: Pergunta[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalData: number;
    };
  };
  selectedPergunta: Pergunta | undefined;
  selectedTemaId: number | undefined;
  setPerguntas: (perguntas: { data: Pergunta[]; pagination: any }) => void;
  setSelectedPergunta: (pergunta: Pergunta) => void;
  setSelectedTemaId: (temaId: number | undefined) => void;
  resetState: () => void;
  removePergunta: (id: number) => void;
  updatePergunta: (pergunta: Pergunta) => void;
}

const usePerguntaStore = create<PerguntaZusProps>()(
  persist(
    (set, get) => ({
      perguntas: defaultValues,
      selectedPergunta: undefined,
      selectedTemaId: undefined,
      setPerguntas: (perguntasResponse) => {
        set({
          perguntas: {
            data: perguntasResponse.data || [],
            pagination: perguntasResponse.pagination || defaultValues.pagination
          }
        });
      },
      setSelectedPergunta: (pergunta: Pergunta) => {
        set({
          selectedPergunta: pergunta
        });
      },
      setSelectedTemaId: (temaId: number | undefined) => {
        set({
          selectedTemaId: temaId
        });
      },
      resetState: () => {
        set({
          perguntas: defaultValues,
          selectedPergunta: undefined,
          selectedTemaId: undefined
        });
      },
      removePergunta: (id: number) => {
        const { perguntas } = get();
        const newState = {
          ...perguntas,
          data: perguntas.data.filter((item) => id !== item.id)
        };
        set({
          perguntas: newState
        });
      },
      updatePergunta: (pergunta: Pergunta) => {
        const { perguntas } = get();
        const newState = {
          ...perguntas,
          data: perguntas.data.map((item) =>
            pergunta.id === item.id ? pergunta : item
          )
        };
        set({
          perguntas: newState,
          selectedPergunta: pergunta
        });
      }
    }),
    {
      name: "perguntas",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default usePerguntaStore;
